const MIB = 1024 * 1024
const MAX_CONCURRENCY = 4
const IN_FLIGHT_MEMORY_BUDGET = 40 * MIB

export function getMaxConcurrency (partSize) {
  if (!Number.isSafeInteger(partSize) || partSize <= 0) {
    throw new Error('分片大小无效')
  }
  return Math.max(1, Math.min(MAX_CONCURRENCY, Math.floor(IN_FLIGHT_MEMORY_BUDGET / partSize)))
}

export async function runUploadQueue ({
  partNumbers,
  concurrency,
  uploadPart,
  onPartComplete,
  shouldStop = () => false
}) {
  let nextIndex = 0
  let firstError = null

  async function worker () {
    while (!firstError && !shouldStop() && nextIndex < partNumbers.length) {
      const partNumber = partNumbers[nextIndex]
      nextIndex += 1
      try {
        const result = await uploadPart(partNumber)
        if (!shouldStop()) {
          await onPartComplete(partNumber, result)
        }
      } catch (error) {
        firstError = firstError || error
      }
    }
  }

  await Promise.all(Array.from(
    { length: Math.min(concurrency, partNumbers.length) },
    () => worker()
  ))
  if (firstError) {
    throw firstError
  }
}
